import { Fragment } from 'react'
import { useTranslation } from 'next-i18next'

import ContentWrapper from '~/tutor-on-demand/components/Content/ContentWrapper'
import HeaderTitle from '~/tutor-on-demand/components/Header/HeaderTitle'
import HeaderWrapper from '~/tutor-on-demand/components/Header/HeaderWrapper'
import TutorOnDemandProductCards from '~/shared/components/TutorOnDemandProductCards/TutorOnDemandProductCards.component'
import Paragraph from '~/tutor-on-demand/components/Typography/Paragraph'
import { SubjectType, getSubjectImage } from '~/components/Metadata/SubjectMetatags'
import ROUTES from '~/shared/constants/routes.const'
import BreadCrumbs from '~/encyclopedia/components/BreadCrumbs'

export default function TutorOnDemandOtherSubjects({ type }: { type: SubjectType }): React.ReactElement {
  const { t } = useTranslation(['tutorOnDemand', 'tutorOnDemandOtherSubjects'])
  const breadcrumbs = [
    { path: ROUTES.TUTOR_ON_DEMAND_INFORMATION, h1: t('tutorOnDemand:landingPage.whatIsTutorOnDemand.title') },
    { path: ROUTES.TUTOR_ON_DEMAND_OTHER_SUBJECTS, h1: t('tutorOnDemandOtherSubjects:title') },
  ]

  return (
    <Fragment>
      <HeaderWrapper>
        <BreadCrumbs
          breadcrumbs={breadcrumbs}
          fontSize="medium"
          isWhite
          itemClassNames="font-medium items-center"
          wrapperClassNames="mt-1 pr-12 lg:pr-0"
        />

        <HeaderTitle
          iconAlt={getSubjectImage(type, t).alt as string}
          iconSrc={getSubjectImage(type, t).srcKey as string}
        >
          {t('tutorOnDemandOtherSubjects:title')}
        </HeaderTitle>
      </HeaderWrapper>
      <ContentWrapper className="space-y-8">
        <div className="xl:space-x-8 xl:flex">
          <section className="mb-6 space-y-6 xl:mb-0">
            <Paragraph>{t('tutorOnDemandOtherSubjects:contentParagraph1')}</Paragraph>
            <Paragraph>{t('tutorOnDemandOtherSubjects:contentParagraph2')}</Paragraph>
            <Paragraph>{t('tutorOnDemandOtherSubjects:contentParagraph3')}</Paragraph>
          </section>
        </div>
        <TutorOnDemandProductCards
          className="pt-6 max-w-max space-y-14 lg:space-y-0 lg:space-x-4 xl:space-x-8 flex flex-col lg:flex-row"
          colorScheme="white"
          hideChatWithTutor
          hideVideoChatWithTutor
        />
      </ContentWrapper>
    </Fragment>
  )
}
